<template>
  <Modal @close="closePopup">
    <div v-html="data.content"></div>

    <a class="button" v-if="buttonCancel" @click="closePopup">Cancel</a>
  </Modal>
</template>

<script>
import Modal from './Modal.vue'

export default {
  components: {
    Modal,
  },
  props: {
    data: Object
  },
  data () {
    return {
      buttonCancel: true
    }
  },
  methods: {
    closePopup () {
      this.$store.commit('setPopup', {
        open: false,
        content: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PopupModal.vue